import { getAmplitudePageNameFromPath } from '@/utils/getPageNameFromPath';
import { getUrlFromPathname } from '@/redux/modules/config';
import { track } from '@/utils/amplitude/analytics/core';
import { TrackingEvents, TrackingPayload } from '@/utils/amplitude/analytics/core.types';
import { useAppSelector } from '@/redux/hooks';
import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

type TrackSearchUnfollowedPayload = TrackingPayload;

export const trackSearchUnfollowedAnalytics = (payload: TrackSearchUnfollowedPayload) => {
    track(TrackingEvents.Search.SearchUnfollowed, payload);
};

export const useTrackSearchUnfollowedAnalytics = () => {
    const { pathname } = useLocation();
    const url = useAppSelector((state) => getUrlFromPathname(state, pathname));

    return useCallback(
        () =>
            trackSearchUnfollowedAnalytics({
                pageName: getAmplitudePageNameFromPath(pathname),
                url,
            }),
        [pathname, url]
    );
};
